/* Recover a Bulk product form when cached availability briefly disagrees with Shopify cart inventory. */
(() => {
  const SOLD_OUT = /already sold out|sold out|not available/i;
  const RETRY_WINDOW_MS = 10_000;
  const lastRecovery = new WeakMap();

  function selectedVariantId(form) {
    const value = form.querySelector('input[name="id"]')?.value;
    return /^\d+$/.test(value || '') ? Number(value) : null;
  }

  async function variantIsAvailable(form) {
    const variantId = selectedVariantId(form);
    if (!variantId) return false;
    const response = await fetch(`${location.pathname}.js?pj_live_inventory=${Date.now()}`, {
      credentials: 'same-origin',
      cache: 'no-store',
      headers: { Accept: 'application/json' },
    });
    if (!response.ok) return false;
    const product = await response.json();
    return product.variants?.some((variant) => variant.id === variantId && variant.available) === true;
  }

  function installRecovery(ProductForm) {
    const prototype = ProductForm?.prototype;
    if (!prototype?.updateErrorMessage || prototype.updateErrorMessage.pjBulkRecovery) return;
    const original = prototype.updateErrorMessage;

    function updateErrorMessage(message = '') {
      if (!SOLD_OUT.test(message)) {
        original.call(this, message);
        return;
      }

      const now = Date.now();
      if (now - (lastRecovery.get(this) || 0) < RETRY_WINDOW_MS) {
        original.call(this, message);
        return;
      }
      lastRecovery.set(this, now);
      original.call(this, 'Refreshing live availability…');

      variantIsAvailable(this)
        .then((available) => {
          if (available && this.isConnected) this.requestSubmit();
          else original.call(this, message);
        })
        .catch(() => original.call(this, message));
    }
    updateErrorMessage.pjBulkRecovery = true;
    prototype.updateErrorMessage = updateErrorMessage;
  }

  async function clearStaleSoldOutAlerts() {
    for (const form of document.querySelectorAll('form[is="product-form"]')) {
      const alert = form.querySelector('[role="alert"]');
      if (!alert || !SOLD_OUT.test(alert.textContent || '')) continue;
      try {
        if (await variantIsAvailable(form)) alert.textContent = '';
      } catch (_) { /* Preserve the original message when availability cannot be confirmed. */ }
    }
  }

  customElements.whenDefined('product-form').then(installRecovery);
  window.addEventListener('pageshow', clearStaleSoldOutAlerts);
})();
